/* tslint:disable */
/* eslint-disable */
export enum KioskRole {
  User = 'User',
  Agency = 'Agency'
}
